
import { takeLatest, takeEvery, put, select } from 'redux-saga/effects'
import i18n from '../i18n'

import * as actions from '../actionTypes'
import { getOrganizationInfo, getSupportedLanguages } from '../api'


export function* changeLanguage(action) {
    const { lang } = action.payload
    i18n.changeLanguage(lang)
    yield put({ type: actions.DECISIONS_REQUESTED, payload: { lang } })
    yield put({ type: actions.APPLY_LANGUAGE, payload: action.payload })
    sessionStorage.setItem('lang', lang)
}

export function* changeSessionLanguage(action) {
  let sessionLang
  if (action.payload.lang) {
    sessionLang = action.payload.lang
  } else {
    sessionLang = yield select(state => state.globalSettings.lang)
  }
  i18n.changeLanguage(sessionLang)
  yield put({ type: actions.APPLY_SESSION_LANGUAGE, payload: action.payload.lang })
}

export function* themeSaga(action) {
  try {
    const {organizationId} = action.payload

    const orgInfo = yield getOrganizationInfo(organizationId)

    yield put({type: actions.THEME_REQUESTED_SUCCESS, payload: orgInfo})

  } catch(error) {
    yield put({type: actions.THEME_REQUESTED_FAILURE, payload: {error}})
  }
}

export function* getSupportedLanguagesSaga() {
  try {
    let response = yield getSupportedLanguages()
    response = response.map(lang => {
      lang.languageCode = lang.languageCode.toLowerCase()
      return lang
    })
    yield put({ type: actions.SUPPORTED_LANG_SUCCESS, payload: response })
  } catch(error) {
    yield put({ type: actions.SUPPORTED_LANG_FAILURE, payload: { error }})
  }
}

export const globalSettingsSagas = [
  takeLatest(actions.LANGUAGE_REQUESTED, changeLanguage),
  takeLatest(actions.SESSION_LANGUAGE_REQUESTED, changeSessionLanguage),
  takeEvery(actions.THEME_REQUESTED, themeSaga),
  takeLatest(actions.SUPPORTED_LANG_REQUESTED, getSupportedLanguagesSaga)
]



// WEBPACK FOOTER //
// ./src/sagas/global-settings.js